import React, { Component } from 'react';
import Typed from 'react-typed'

import feedback1 from '../images/feedback-1.png'
import feedback2 from '../images/feedbck-2.png'
import feedback3 from '../images/feedback-3.png'
import feedback4 from '../images/feedback-4.jpg'
import feedback5 from '../images/feedback-5.png'
import feedback6 from '../images/feedback-6.png'


export class testimonials extends Component {
      
      render() {
            return (
                  <div className="testimonial" id="people">
                        <div className="d-flex justify-content-center">
                              <h1 className="testimonials-statement"><Typed  strings={['What People are Saying On Fiverr......']}
                                    typeSpeed={70} backSpeed={70}   /></h1>
                        </div>
                        <div className="container testimonial-container">
                              <div className="d-flex justify-content-center mt-3 testimonial-animation">
                                    <img src={feedback1} className=" a2" alt="fiverr"   />     
                              </div>
                              <div className="d-flex mt-3 testimonial-animation">
                                          <img src={feedback2} className=" a3" alt=""/>
                                          <img src={feedback4} className=" a4" alt=""   />
                                    
                              </div>
                              <div className="d-flex mt-3 ml-2 testimonial-animation">
                                          <img src={feedback5} className=" a5" alt=""/>
                                          <img src={feedback6} className=" a6" alt=""/>
                              </div>
                              <div className="d-flex justify-content-center mt-3 testimonial-animation">
                                    <img src={feedback3} className=" a7" alt="fiverr"   />     
                              </div>
                        </div>
                  </div>
            );
      }
}

export default testimonials;
